import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ApiService from '../services/ApiService';
import AddDevicePopup from './AddDevicePopup';
import { Upload, X, Plus } from 'lucide-react';
import "./EditDeviceDetails.css"

function EditDeviceDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const [deviceDetails, setDeviceDetails] = useState([]);
  const [productMeta, setProductMeta] = useState({});

  useEffect(() => {
    const product = location?.state?.product;
    console.log(product, 'product');
    if (product && product.device) {
      const filledDevices = product.device.map((d) => ({
        id: d.id,
        name: d.name || '',
        model: d.model || '',
        description: d.description || '',
        photos: Array.isArray(d.image) ? [...d.image] : (d.image ? [d.image] : []),
        imagePreviews: Array.isArray(d.image) ? [...d.image] : (d.image ? [d.image] : []),
        isRelay: !!d.isRelay,
        relayAmt: d.relayAmt || '',
        amount: d.amount || '',
        isSubscription: !!d.isSubscription,

        isMonthlySubscription: !!d.isMonthlySubscription,
        subscriptionMonthlyAmt: d.subscriptionMonthlyAmt || 0,

        isYearlySubscription: !!d.isYearlySubscription,
        subscriptionYearlyAmt: d.subscriptionYearlyAmt || 0,

        isTwoYearSubscription: !!d.isTwoYearSubscription,
        subscriptionTwoYearAmt: d.subscriptionTwoYearAmt || 0,

        isNetwork: (d.network2gAmt >= 0 || d.network4gAmt >= 0) ? true : false,
        is2G: d.network2gAmt >= 0,
        is4G: d.network4gAmt >= 0,
        network2gAmt: d.network2gAmt >= 0 ? d.network2gAmt : '',
        network4gAmt: d.network4gAmt >= 0 ? d.network4gAmt : '',
        discount: d.discount || 0,
        applications: d.points ? d.points.map(point => ({
          name: point.title || '',
          desc: point.desc || '',
          photo: null,
          preview: point.file || '',
          existingFile: point.file
        })) : []
      }));
      setDeviceDetails(filledDevices);

      setProductMeta({
        companyCode: product.companyCode,
        unitCode: product.unitCode,
        webProductId: product.id,
        webProductName: product.name,
      });
    }
  }, [location.state?.product]);

  // const handleChange = (index, field, value) => {
  //   setDeviceDetails((prev) => {
  //     const updated = [...prev];
  //     updated[index][field] = value;
  //     return updated;
  //   });
  // };

  const handleChange = (index, field, value) => {
    setDeviceDetails((prev) => {
      const updated = [...prev];

      let newValue = value;

      if (field === 'isSubscription' || field === 'isRelay' || field === 'isNetwork' || field === 'is2G' || field === 'is4G') {
        newValue = value === true || value === 'true';
      }

      updated[index][field] = newValue;

      // RESET subscription (like FormStepFour)
      if (field === 'isSubscription' && !newValue) {
        updated[index].isMonthlySubscription = false;
        updated[index].isYearlySubscription = false;
        updated[index].isTwoYearSubscription = false;

        updated[index].subscriptionMonthlyAmt = 0;
        updated[index].subscriptionYearlyAmt = 0;
        updated[index].subscriptionTwoYearAmt = 0;
      }

      return updated;
    });
  };

  const [showModal, setShowModal] = useState(false);

  const handleImageChange = (index, files) => {
    setDeviceDetails((prev) => {
      const updated = [...prev];
      const newPhotos = [...(updated[index].photos || [])];
      const newPreviews = [...(updated[index].imagePreviews || [])];

      Array.from(files).forEach(file => {
        newPhotos.push(file);
        newPreviews.push(URL.createObjectURL(file));
      });

      updated[index].photos = newPhotos;
      updated[index].imagePreviews = newPreviews;
      return updated;
    });
  };

  // Remove specific image
  const handleRemoveImage = (deviceIndex, imageIndex) => {
    setDeviceDetails((prev) => {
      const updated = [...prev];
      // updated[deviceIndex].photos.splice(imageIndex, 1);
      // updated[deviceIndex].imagePreviews.splice(imageIndex, 1);
      // return updated;

      const newPhotos = [...updated[deviceIndex].photos];
      const newPreviews = [...updated[deviceIndex].imagePreviews];

      newPhotos.splice(imageIndex, 1);
      newPreviews.splice(imageIndex, 1);

      updated[deviceIndex].photos = newPhotos;
      updated[deviceIndex].imagePreviews = newPreviews;

      return updated;
    });
  };

  // Handle application changes
  const handleApplicationChange = (deviceIndex, appIndex, field, value) => {
    setDeviceDetails((prev) => {
      const updated = [...prev];
      if (!updated[deviceIndex].applications) {
        updated[deviceIndex].applications = [];
      }
      updated[deviceIndex].applications[appIndex][field] = value;
      return updated;
    });
  };

  // Add new application
  const addApplication = (deviceIndex) => {
    setDeviceDetails((prev) => {
      const updated = [...prev];
      if (!updated[deviceIndex].applications) {
        updated[deviceIndex].applications = [];
      }
      updated[deviceIndex].applications.push({
        name: '',
        desc: '',
        photo: null,
        preview: null
      });
      return updated;
    });
  };

  // Remove application
  const removeApplication = (deviceIndex, appIndex) => {
    setDeviceDetails((prev) => {
      const updated = [...prev];
      updated[deviceIndex].applications.splice(appIndex, 1);
      return updated;
    });
  };

  // Handle application image upload
  const handleApplicationImageChange = (deviceIndex, appIndex, file) => {
    if (file) {
      setDeviceDetails((prev) => {
        const updated = [...prev];
        updated[deviceIndex].applications[appIndex].photo = file;
        updated[deviceIndex].applications[appIndex].preview = URL.createObjectURL(file);
        updated[deviceIndex].applications[appIndex].existingFile = '';
        return updated;
      });
    }
  };

  console.log(deviceDetails, 'deviceDetails');

  const handleSingleSubmit = async (device) => {
    const formData = new FormData();

    formData.append('companyCode', productMeta.companyCode);
    formData.append('unitCode', productMeta.unitCode);

    if (device.id && Number(device.id) !== 0) {
      formData.append('id', device.id);
    }

    formData.append('name', device.name);
    formData.append('model', device.model);
    formData.append('description', device.description);

    formData.append(
      'amount',
      device.amount === '' ? 0 : Number(device.amount || 0)
    );

    formData.append('webProductId', productMeta.webProductId);
    formData.append('webProductName', productMeta.webProductName);

    // =========================
    // RELAY (safe)
    // =========================
    const isRelay = !!device.isRelay;

    formData.append('isRelay', isRelay ? 1 : 0);
    formData.append('relayAmt', isRelay ? Number(device.relayAmt || 0) : 0);

    // =========================
    // SUBSCRIPTION (safe reset logic)
    // =========================
    const isSubscription = !!device.isSubscription;

    const isMonthly = isSubscription && !!device.isMonthlySubscription;
    const isYearly = isSubscription && !!device.isYearlySubscription;
    const isTwoYear = isSubscription && !!device.isTwoYearSubscription;

    formData.append('isSubscription', isSubscription ? 1 : 0);

    formData.append('isMonthlySubscription', isMonthly ? 1 : 0);
    formData.append(
      'subscriptionMonthlyAmt',
      isMonthly ? Number(device.subscriptionMonthlyAmt || 0) : 0
    );

    formData.append('isYearlySubscription', isYearly ? 1 : 0);
    formData.append(
      'subscriptionYearlyAmt',
      isYearly ? Number(device.subscriptionYearlyAmt || 0) : 0
    );

    formData.append('isTwoYearSubscription', isTwoYear ? 1 : 0);
    formData.append(
      'subscriptionTwoYearAmt',
      isTwoYear ? Number(device.subscriptionTwoYearAmt || 0) : 0
    );

    // =========================
    // NETWORK (IMPORTANT FIX)
    // =========================
    const isNetwork = !!device.isNetwork;

    const is2G = isNetwork && !!device.is2G;
    const is4G = isNetwork && !!device.is4G;

    formData.append('isNetwork', isNetwork ? 1 : 0);

    formData.append(
      'network2gAmt',
      is2G ? Number(device.network2gAmt || 0) : -1
    );

    formData.append(
      'network4gAmt',
      is4G ? Number(device.network4gAmt || 0) : -1
    );

    // =========================
    // OTHER FIELDS
    // =========================
    formData.append(
      'discount',
      device.discount === '' ? 0 : Number(device.discount || 0)
    );

    // =========================
    // IMAGES
    // =========================
    if (device.photos?.length > 0) {
      for (const photo of device.photos) {
        if (photo instanceof File) {
          formData.append('mediaFiles', photo, photo.name);
        } else if (typeof photo === 'string' && photo.startsWith('http')) {
          try {
            const response = await fetch(photo);
            const blob = await response.blob();
            const fileName = `image_${Date.now()}.png`;

            const file = new File([blob], fileName, { type: blob.type });
            formData.append('mediaFiles', file, fileName);
          } catch (error) {
            console.error(`Failed to fetch image ${photo}:`, error);
          }
        }
      }
    }

    // =========================
    // APPLICATIONS
    // =========================
    if (device.applications?.length > 0) {
      device.applications.forEach((app, index) => {
        formData.append(`points[${index}].title`, app.name || '');
        formData.append(`points[${index}].desc`, app.desc || '');

        if (app.photo instanceof File) {
          formData.append(`points[${index}].file`, '');
          formData.append(`pointFiles_${index}`, app.photo, app.photo.name);
        } else {
          formData.append(
            `points[${index}].file`,
            app.existingFile || app.preview || ''
          );
        }
      });
    }

    // =========================
    // API CALL
    // =========================
    try {
      const res = await ApiService.post(
        '/device/handleDeviceDetails',
        formData
      );

      console.log(`Device ${device.id} updated successfully:`, res.data);
      alert(`Device "${device.name}" updated successfully`);

      navigate('/ceoui');
    } catch (error) {
      console.error(`Failed to update device ${device.id}:`, error);
      alert(`Failed to update device "${device.name}"`);
    }
  };

  const handleAddNewDevice = () => {
    setDeviceDetails((prev) => [
      ...prev,
      {
        id: '',
        name: '',
        model: '',
        description: '',
        photos: [],
        image: null,
        imagePreview: '',
        isRelay: false,
        relayAmt: '',
        amount: '',
        isSubscription: false,
        subscriptionMonthlyAmt: '',
        subscriptionYearlyAmt: '',
        isNetwork: false,
        network4gAmt: '',
        network2gAmt: '',
        discount: '',
        applications: []
      },
    ]);
  };

  const handleRemoveDevice = async (indexToRemove) => {
    const id = indexToRemove;
    setDeviceDetails((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
    try {
      const res = await ApiService.post('/device/deleteDeviceDetails', {
        id: id,
      });
      console.log(`Device ${id} deleted successfully:`, res.data);
      alert(`Device "${id}" deleted successfully`);
      // navigate('/ceoui');
    } catch (error) {
      console.error(`Failed to update device ${id}:`, error);
      alert(`Failed to update device "${id}"`);
    }
  };

  const handleSaveDevice = (newDevice) => {
    // setDeviceDetails((prev) => [...prev, newDevice]);
    handleSingleSubmit(newDevice)
  };

  const handleReplaceImage = (deviceIndex, imageIndex, file) => {
    if (!file) return;

    setDeviceDetails((prev) => {
      const updated = [...prev];

      const newPhotos = [...updated[deviceIndex].photos];
      const newPreviews = [...updated[deviceIndex].imagePreviews];

      // Replace file
      newPhotos[imageIndex] = file;

      // Replace preview
      newPreviews[imageIndex] = URL.createObjectURL(file);

      updated[deviceIndex].photos = newPhotos;
      updated[deviceIndex].imagePreviews = newPreviews;

      return updated;
    });
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-semibold mb-2">Devices</h2>
      <p className="text-gray-500 mb-6">
        Update each device's model, image, pricing, and additional info.
      </p>


      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow-sm mb-6"
      >
        + Add New Device
      </button>

      {deviceDetails.map((device, index) => (
        <div key={index} className="border border-gray-200 rounded-md mb-6">
          <div className="bg-gray-100 px-4 py-2 rounded-t-md font-medium">
            Device {index + 1}
          </div>

          <div className="p-4 space-y-4">
            <div>
              <label className="block text-sm font-medium">Name</label>
              <input
                type="text"
                value={device.name}
                onChange={(e) => handleChange(index, 'name', e.target.value)}
                className="mt-1 block w-full border p-2 rounded-md"
              />
            </div>

            <div>
              <label className="block text-sm font-medium">Model</label>
              <input
                type="text"
                value={device.model}
                onChange={(e) => handleChange(index, 'model', e.target.value)}
                className="mt-1 block w-full border p-2 rounded-md"
              />
            </div>

            <div>
              <label className="block text-sm font-medium">Description</label>
              <textarea
                value={device.description}
                onChange={(e) =>
                  handleChange(index, 'description', e.target.value)
                }
                className="mt-1 block w-full border p-2 rounded-md"
              />
            </div>

            {/* Device Images */}
            <div>
              <label className="block text-sm font-medium mb-1">Device Images</label>
              <div className="space-y-4">
                {device.imagePreviews && device.imagePreviews.map((preview, photoIndex) => (
                  <div key={photoIndex} className="relative border border-gray-200 rounded-lg p-4 bg-white">


                    <div className="relative">
                      <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center text-white text-sm opacity-0 group-hover:opacity-100 transition pointer-events-none">
                        Click to replace
                      </div>
                      <img
                        src={preview}
                        alt={`Device ${index + 1} - Image ${photoIndex + 1}`}
                        className="w-full h-40 object-cover rounded-md cursor-pointer hover:opacity-80"
                        onClick={() =>
                          document.getElementById(`replace-image-${index}-${photoIndex}`).click()
                        }
                      />

                      <input
                        type="file"
                        accept="image/*"
                        id={`replace-image-${index}-${photoIndex}`}
                        className="hidden"
                        onChange={(e) =>
                          handleReplaceImage(index, photoIndex, e.target.files[0])
                        }
                      />

                      <button
                        type="button"
                        className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600"
                        onClick={() => handleRemoveImage(index, photoIndex)}
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                ))}

                {/* Upload Field */}
                <div className="flex items-center justify-center w-full">
                  <label
                    htmlFor={`device-photo-${index}`}
                    className="w-full flex flex-col items-center px-4 py-6 bg-white rounded-lg border-2 border-dashed border-gray-300 cursor-pointer hover:bg-gray-50"
                  >
                    <div className="flex items-center justify-center">
                      <Upload className="h-5 w-5 text-gray-400" />
                      <span className="ml-2 text-sm text-gray-500">Add Device Image</span>
                    </div>
                    <input
                      type="file"
                      id={`device-photo-${index}`}
                      className="hidden"
                      accept="image/*"
                      multiple
                      onChange={(e) => handleImageChange(index, e.target.files)}
                    />
                  </label>
                </div>
              </div>
            </div>

            {/* Applications */}
            <div>
              <label className="block text-sm font-medium mb-2">Applications</label>
              {device.applications && device.applications.map((app, appIndex) => (
                <div key={appIndex} className="bg-gray-50 rounded-lg p-4 relative border border-gray-200 mb-3">
                  <div className="flex flex-col mb-2">
                    <input
                      type="text"
                      placeholder="Application Name"
                      className="mt-1 block w-full border p-2 rounded-md mb-2"
                      value={app.name}
                      onChange={(e) => handleApplicationChange(index, appIndex, 'name', e.target.value)}
                    />
                    <textarea
                      placeholder="Description"
                      className="mt-1 block w-full border p-2 rounded-md mb-2"
                      value={app.desc}
                      onChange={(e) => handleApplicationChange(index, appIndex, 'desc', e.target.value)}
                    />
                  </div>

                  <div className="flex items-center justify-center w-full mb-2">
                    <label className="w-full flex flex-col items-center px-4 py-6 bg-white rounded-lg border-2 border-dashed border-gray-300 cursor-pointer hover:bg-gray-50">
                      <div className="flex items-center justify-center">
                        <Upload className="h-5 w-5 text-gray-400" />
                        <span className="ml-2 text-sm text-gray-500">Add Application Image</span>
                      </div>
                      <input
                        type="file"
                        className="hidden"
                        accept="image/*"
                        onChange={(e) => handleApplicationImageChange(index, appIndex, e.target.files[0])}
                      />
                    </label>
                  </div>

                  {app.preview && (
                    <div className="relative mb-2">
                      <img src={app.preview} alt="Application" className="w-full h-40 object-cover rounded-md" />
                      <button
                        type="button"
                        className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600"
                        onClick={() => {
                          handleApplicationChange(index, appIndex, 'photo', null);
                          handleApplicationChange(index, appIndex, 'preview', null);
                          handleApplicationChange(index, appIndex, 'existingFile', '');
                        }}
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  )}

                  <button
                    type="button"
                    className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600"
                    onClick={() => removeApplication(index, appIndex)}
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              ))}

              {(device.applications?.length || 0) < 10 && (
                <button
                  type="button"
                  className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow-sm transition"
                  onClick={() => addApplication(index)}
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Add Application
                </button>
              )}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium">Amount</label>
                <input
                  type="number"
                  value={device.amount}
                  onChange={(e) =>
                    handleChange(index, 'amount', e.target.value)
                  }
                  className="mt-1 block w-full border p-2 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium">
                  Discount (%)
                </label>
                <input
                  type="number"
                  value={device.discount}
                  onChange={(e) =>
                    handleChange(index, 'discount', e.target.value)
                  }
                  className="mt-1 block w-full border p-2 rounded-md"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium">Relay</label>
                <select
                  value={device.isRelay}
                  onChange={(e) =>
                    handleChange(index, 'isRelay', e.target.value === 'true')
                  }
                  className="mt-1 block w-full border p-2 rounded-md"
                >
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>
              {device.isRelay && (
                <div>
                  <label className="block text-sm font-medium">
                    Relay Amount
                  </label>
                  <input
                    type="number"
                    value={device.relayAmt}
                    onChange={(e) =>
                      handleChange(index, 'relayAmt', e.target.value)
                    }
                    className="mt-1 block w-full border p-2 rounded-md"
                  />
                </div>
              )}
            </div>

            <div className="border rounded-lg p-4 bg-white mb-4">
              <h3 className="font-medium mb-3">Subscription Options</h3>

              {/* Master Toggle */}
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm font-medium">Enable Subscription</span>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={device.isSubscription || false}
                    onChange={(e) =>
                      handleChange(index, 'isSubscription', e.target.checked)
                    }
                  />
                  <div className="w-10 h-5 bg-gray-300 peer-checked:bg-green-500 rounded-full relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:after:translate-x-5"></div>
                </label>
              </div>

              {/* CHILD OPTIONS */}
              {device.isSubscription && (
                <div className="space-y-4">

                  {/* MONTHLY */}
                  <div className="border rounded-md p-3">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium">Monthly Plan</span>

                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={device.isMonthlySubscription || false}
                          onChange={(e) =>
                            handleChange(index, 'isMonthlySubscription', e.target.checked)
                          }
                        />
                        <div className="w-10 h-5 bg-gray-300 peer-checked:bg-green-500 rounded-full relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:after:translate-x-5"></div>
                      </label>
                    </div>

                    {device.isMonthlySubscription && (
                      <input
                        type="number"
                        placeholder="Monthly Amount"
                        value={device.subscriptionMonthlyAmt || ''}
                        onChange={(e) =>
                          handleChange(index, 'subscriptionMonthlyAmt', e.target.value)
                        }
                        className="w-full border p-2 rounded-md"
                      />
                    )}
                  </div>

                  {/* YEARLY */}
                  <div className="border rounded-md p-3">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium">Yearly Plan</span>

                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={device.isYearlySubscription || false}
                          onChange={(e) =>
                            handleChange(index, 'isYearlySubscription', e.target.checked)
                          }
                        />
                        <div className="w-10 h-5 bg-gray-300 peer-checked:bg-green-500 rounded-full relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:after:translate-x-5"></div>
                      </label>
                    </div>

                    {device.isYearlySubscription && (
                      <input
                        type="number"
                        placeholder="Yearly Amount"
                        value={device.subscriptionYearlyAmt || ''}
                        onChange={(e) =>
                          handleChange(index, 'subscriptionYearlyAmt', e.target.value)
                        }
                        className="w-full border p-2 rounded-md"
                      />
                    )}
                  </div>

                  {/* 2 YEAR */}
                  <div className="border rounded-md p-3 bg-gray-50">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium">2 Year Plan</span>

                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={device.isTwoYearSubscription || false}
                          onChange={(e) =>
                            handleChange(index, 'isTwoYearSubscription', e.target.checked)
                          }
                        />
                        <div className="w-10 h-5 bg-gray-300 peer-checked:bg-green-500 rounded-full relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:after:translate-x-5"></div>
                      </label>
                    </div>

                    {device.isTwoYearSubscription && (
                      <input
                        type="number"
                        placeholder="2 Year Amount"
                        value={device.subscriptionTwoYearAmt || ''}
                        onChange={(e) =>
                          handleChange(index, 'subscriptionTwoYearAmt', e.target.value)
                        }
                        className="w-full border p-2 rounded-md"
                      />
                    )}
                  </div>

                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium">
                Network Support
              </label>
              <select
                value={device.isNetwork}
                onChange={(e) =>
                  handleChange(index, 'isNetwork', e.target.value === 'true')
                }
                className="mt-1 block w-full border p-2 rounded-md"
              >
                <option value="false">No</option>
                <option value="true">Yes</option>
              </select>
            </div>

            {device.isNetwork && (
              <div className="grid grid-cols-2 gap-4 mt-2">
                {/* 2G Network */}
                <div className="border border-gray-200 rounded-md p-3">
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-medium">2G Network</label>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={device.is2G || false}
                        onChange={(e) => handleChange(index, 'is2G', e.target.checked)}
                      />
                      <div className="w-10 h-5 bg-gray-300 peer-checked:bg-green-500 rounded-full relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:after:translate-x-5"></div>
                    </label>
                  </div>

                  {device.is2G && (
                    <input
                      type="number"
                      placeholder="Enter 2G Amount"
                      className="mt-1 block w-full border p-2 rounded-md"
                      value={device.network2gAmt || ''}
                      onChange={(e) => handleChange(index, 'network2gAmt', e.target.value)}
                    />
                  )}
                </div>

                {/* 4G Network */}
                <div className="border border-gray-200 rounded-md p-3">
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-medium">4G Network</label>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={device.is4G || false}
                        onChange={(e) => handleChange(index, 'is4G', e.target.checked)}
                      />
                      <div className="w-10 h-5 bg-gray-300 peer-checked:bg-green-500 rounded-full relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:after:translate-x-5"></div>
                    </label>
                  </div>

                  {device.is4G && (
                    <input
                      type="number"
                      placeholder="Enter 4G Amount"
                      className="mt-1 block w-full border p-2 rounded-md"
                      value={device.network4gAmt || ''}
                      onChange={(e) => handleChange(index, 'network4gAmt', e.target.value)}
                    />
                  )}
                </div>
              </div>
            )}

            <div className="pt-2 flex gap-4">
              <button
                type="button"
                onClick={() => handleSingleSubmit(device)}
                className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg shadow-sm transition"
              >
                Update
              </button>
              <button
                type="button"
                onClick={() => handleRemoveDevice(device.id)}
                className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg shadow-sm transition"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      ))}

      {showModal && (
        <AddDevicePopup
          onClose={() => setShowModal(false)}
          onSave={handleSaveDevice}
        />
      )}
    </div>
  );
}

export default EditDeviceDetails;
